import { Button, Container, TextBox, Image } from "./pageElements"

export class HelpModal {
    constructor(helpScreenData) {
        this.modalDiv = document.createElement('div');
        this.modalDiv.id = "modalDiv";
        document.body.appendChild(this.modalDiv);

        this.modalBackground = document.createElement('div');
        this.modalBackground.id = "modalBackground";
        document.body.appendChild(this.modalBackground);

        this.closeButton = document.createElement('span');
        this.closeButton.id = "closeModalButton";
        this.closeButton.innerHTML = "&times"
        this.modalDiv.appendChild(this.closeButton);
        this.closeButton.onclick = () => {
            this.modalBackground.style.display = "none";
            this.modalDiv.style.display = "none";
        }

        this.helpButton = new Button("Help", "uiControlContainer", () => {
            this.modalBackground.style.display = "block";
            this.modalDiv.style.display = "block";
        })

        this.modalContainer = new Container("modalContainer", "modalDiv", true);

        this.titleText = new TextBox("modalTitleText", "modalDiv", "Help Screen");
        this.modalContainer.addBlock(this.titleText);

        let sections = Object.entries(helpScreenData);
        sections.forEach(section => {
            this.addSection(section[0], section[1]);
        })
    }

    getButton() {
        return this.helpButton;
    }

    addSection(name, sectionInfo) {
        let sectionContainer = new Container("sectionContainer", "modalDiv", true)

        let textContainer = new Container("sectionTextContainer", "modalDiv", true);
        textContainer.div.classList.add("sectionTextDiv");

        let button = new Button(name, "modalDiv", () => {
            button.button.classList.toggle("activeSectionButton");
            if (textContainer.div.style.maxHeight) {
                textContainer.div.style.maxHeight = null;
            } else {
                textContainer.div.style.maxHeight = textContainer.div.scrollHeight + "px";
            }
        })
        button.button.classList.add("sectionButton")
        button.div.classList.add("sectionButtonDiv");

        sectionContainer.addBlock(button, textContainer)
        this.modalContainer.addBlock(sectionContainer);

        // help info
        sectionInfo.forEach(group => {
            if (group.type == "text") {
                let textbox = new TextBox("helpText", "modalDiv", group.data);
                textContainer.addBlock(textbox);
            } else if (group.type == "header") {
                let textbox = new TextBox("helpText", "modalDiv", group.data);
                textbox.div.classList.add("sectionHeader");
                textContainer.addBlock(textbox);
            } else if (group.type == "image") {
                let image = new Image("sectionImage_" + group.data, "modalDiv", group.data);
                textContainer.addBlock(image);
                if(group.size) {
                    image.image.style.maxWidth = group.size;
                }
            }
        })
    }
}